import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const toolbarOptions = [
  [{ font: [] }, { size: [] }],
  ["bold", "italic", "underline", "strike"],
  [{ script: "sub" }, { script: "super" }],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ align: [] }],
  ["link"],
  ["clean"],
];

const CustomTextEditor = ({ editorContent, setEditorContent }) => {
  const handleEditorChange = (content) => {
    // console.log("handleEidt chang", handleEditorChange);
    setEditorContent(content);
  };
  // console.log("editorContent", editorContent);
  return (
    <ReactQuill
      value={editorContent || ""} // Ensure there's always a fallback value
      onChange={handleEditorChange}
      theme="snow"
      modules={{ toolbar: toolbarOptions }}
      className="bg-white shadow-sm rounded-md min-h-[200px]" // Adjust the height here
    />
  );
};

export default CustomTextEditor;
